const turboVisitOnClick = (e: Event): void => {
  e.preventDefault()
  e.stopPropagation()
  const target = e.currentTarget as HTMLAnchorElement
  Turbolinks.visit(target.href)
}

window.onDomLoad(function () {
  const clickableItems = document.querySelectorAll(
    "[data-behavior~='clickable-item']"
  )

  clickableItems.forEach((item) => {
    const link = item.querySelector("[data-behavior~='clickable-link']")

    if (link) {
      link.addEventListener('click', turboVisitOnClick)
    }
  })
})
